import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import 'core-js/stable';
import 'regenerator-runtime/runtime';
import './utils/browserSupport.js';

import * as Sentry from '@sentry/browser';
import React from 'react';
import ReactDOM from 'react-dom';
import { createRoot } from 'react-dom/client';
import ReactGA4 from 'react-ga4';

import App from './App';
import * as serviceWorker from './registerServiceWorker';
import { store as originalStore } from './store/configureStore';

export const store = originalStore;

// GA4 INITIALIZATION
const MEASUREMENT_ID = process.env.REACT_APP_GA4_MEASUREMENT_ID;
ReactGA4.initialize([
  {
    trackingId: MEASUREMENT_ID, // MEASUREMENT_ID
    gaOptions: {
      allowLinker: true,
    },
  },
]);

const SENTRY_URL = process.env.REACT_APP_SENTRY_URL;
Sentry.init({
  dsn: SENTRY_URL,
  environment: process.env.REACT_APP_ENVIRONMENT,
  ignoreErrors: [/^Request failed with status code 401$/],
});

const container = document.getElementById('root');
const root = createRoot(container);
root.render(<App store={originalStore} />);

serviceWorker.unregister();
